import pythonApi from '../api/pythonApi';

class AssetMaintenanceNotesService {
  getMaintenanceNotes = async (asset_id: string) => {
    let url = `/api/v1/asset-maintenance-notes?asset_id=${asset_id}`;
    const response = await pythonApi.get(url);
    return response.data;
  }

  createMaintenanceNote = async (payload: {
    asset_id: string;  // Can be sensorbox_group id (for assets) or sensor_box_name (for sensorboxes)
    notes: string;
    status: string;
    created_on?: number;
  }) => {
    const url = `/api/v1/asset-maintenance-notes`;
    const response = await pythonApi.post(url, payload);
    return response.data;
  }

  updateMaintenanceNote = async (note_id: string, payload: {
    note_id?: string;
    notes?: string;
    status?: string;
    created_on?: number;
  }) => {
    const url = `/api/v1/asset-maintenance-notes/${note_id}`;
    const response = await pythonApi.put(url, payload);
    return response.data;
  }

  deleteMaintenanceNote = async (note_id: string) => {
    const url = `/api/v1/asset-maintenance-notes/${note_id}`;
    const response = await pythonApi.delete(url);
    return response.data;
  }
}

const instance = new AssetMaintenanceNotesService();

export default instance;